import { Typography } from "@material-ui/core";
import BatchOverviewGrid from "components/BatchOverviewGrid/BatchOverviewGrid";
import { numberAfterDotCounter } from "helpers/numberAfterDotCounter";
import moment from "moment";
import React from "react";
import { DeviceDetailsInfo } from "./DeviceDetailsInfo";

export default function DeviceDetails(props: DeviceDetailsInfo) {
    return (
        <div style={{ marginTop: "50px" }}>
            <Typography variant="h5">Monitor Configuration</Typography>
            <BatchOverviewGrid
                gridXS={2}
                data={[
                    {
                        subTitle: "Startup delay",
                        item: props.configuration.startupDelay,
                    },
                    {
                        subTitle: "Interval",
                        item: props.configuration.interval,
                    },
                    {
                        subTitle: "",
                        item: "",
                    },
                    {
                        subTitle: "",
                        item: "",
                    },
                    {
                        subTitle: "",
                        item: "",
                    },
                ]}
            />
            <Typography variant="h5" style={{ marginTop: "50px" }}>
                Monitor Read
            </Typography>
            <BatchOverviewGrid
                gridXS={2}
                data={[
                    {
                        subTitle: "On",
                        item: moment.utc(props.readInformation.deviceReadOn).format("DD MMM YYYY HH:mm:ss "),
                    },
                    {
                        subTitle: "By",
                        item: props.readInformation.deviceReadBy,
                    },
                    {
                        subTitle: "Note",
                        item: props.readInformation.notes,
                    },
                    {
                        subTitle: "",
                        item: "",
                    },
                    {
                        subTitle: "",
                        item: "",
                    },
                ]}
            />
            <Typography variant="h5" style={{ marginTop: "50px" }}>
                Recorded Data
            </Typography>
            <BatchOverviewGrid
                gridXS={2}
                data={[
                    {
                        subTitle: "First point",
                        item: moment.utc(props.recordingInformation.firstDataPoint).format("DD MMM YYYY HH:mm:ss "),
                    },
                    {
                        subTitle: "Stop Time",
                        item: moment.utc(props.recordingInformation.stopTime).format("DD MMM YYYY HH:mm:ss "),
                    },
                    {
                        subTitle: "Trip Length",
                        item: props.recordingInformation.tripLength,
                    },
                    {
                        subTitle: "",
                        item: "",
                    },
                    {
                        subTitle: "",
                        item: "",
                    },
                ]}
            />
            <Typography variant="h5" style={{ marginTop: "50px" }}>
                Summary Data
            </Typography>
            <BatchOverviewGrid
                gridXS={2}
                data={[
                    {
                        subTitle: "Low Extreme",
                        item: numberAfterDotCounter(props.summaryData.lowExtremeTemperature) + "°C",
                        enteredText: moment
                            .utc(props.summaryData.lowExtremeTemperatureDate)
                            .format("DD MMM YYYY HH:mm:ss "),
                    },
                    {
                        subTitle: "High Extreme",
                        item: numberAfterDotCounter(props.summaryData.highExtremeTemperature) + "°C",
                        enteredText: moment
                            .utc(props.summaryData.highExtremeTemperatureDate)
                            .format("DD MMM YYYY HH:mm:ss "),
                    },
                    {
                        subTitle: "Mean ± STD Deviation",
                        item:
                            numberAfterDotCounter(props.summaryData.meanTemperature) +
                            "°C ± " +
                            numberAfterDotCounter(props.summaryData.meanDeviation) +
                            "°C",
                    },
                    {
                        subTitle: "Mean Kinetic Temperature",
                        item: numberAfterDotCounter(props.summaryData.meanKineticTemperature) + "°C",
                    },
                    {
                        subTitle: "Activation Energy",
                        item: numberAfterDotCounter(props.summaryData.activationEnergyKjMol) + " kj/mol",
                    },
                ]}
            />
        </div>
    );
}
